import type { PublicSlotKey } from '#packages/apilib';
import type { AnimationsApi } from './publicApi';

export const AnimationsApiKey: PublicSlotKey<AnimationsApi> = {
  name: 'AnimationsApi',
  public: true,
};
